import { getTheme } from "../../../../graphic/theme";

import { canvasAllocate } from "../../../../allocator/canvas-allocate";

import { BaseRenderContributionTime } from "../../../../common/enums";

export class DefaultBaseBackgroundRenderContribution {
    constructor() {
        this.time = BaseRenderContributionTime.beforeFillStroke, this.useStyle = !0, this.order = 0;
    }
    drawShape(graphic, context, x, y, doFill, doStroke, fVisible, sVisible, graphicAttribute, drawContext, fillCb, strokeCb, options) {
        var _a;
        const {background: background, backgroundOpacity: backgroundOpacity = (null !== (_a = graphic.attribute.fillOpacity) && void 0 !== _a ? _a : graphicAttribute.backgroundOpacity), opacity: opacity = graphicAttribute.opacity, backgroundMode: backgroundMode = graphicAttribute.backgroundMode, backgroundFit: backgroundFit = graphicAttribute.backgroundFit, backgroundKeepAspectRatio: backgroundKeepAspectRatio = graphicAttribute.backgroundKeepAspectRatio, backgroundScale: backgroundScale = graphicAttribute.backgroundScale, backgroundOffsetX: backgroundOffsetX = graphicAttribute.backgroundOffsetX, backgroundOffsetY: backgroundOffsetY = graphicAttribute.backgroundOffsetY, backgroundClip: backgroundClip = graphicAttribute.backgroundClip, backgroundPosition: backgroundPosition = graphicAttribute.backgroundPosition} = graphic.attribute;
        if (background) if (graphic.backgroundImg && graphic.resources) {
            const res = graphic.resources.get(getBackgroundImage(background));
            if (!res || "success" !== res.state || !res.data) return;
            if (context.save(), graphic.parent && !graphic.transMatrix.onlyTranslate()) {
                const groupAttribute = getTheme(graphic.parent).group, {scrollX: scrollX = groupAttribute.scrollX, scrollY: scrollY = groupAttribute.scrollY} = graphic.parent.attribute;
                context.setTransformFromMatrix(graphic.parent.globalTransMatrix, !0), context.translate(scrollX, scrollY);
            }
            backgroundClip && context.clip();
            const b = graphic.AABBBounds;
            context.setCommonStyle(graphic, graphic.attribute, x, y, graphicAttribute), context.globalAlpha = backgroundOpacity * opacity, 
            this.doDrawImage(context, res.data, b, {
                backgroundMode: backgroundMode,
                backgroundFit: backgroundFit,
                backgroundKeepAspectRatio: backgroundKeepAspectRatio,
                backgroundScale: backgroundScale,
                backgroundOffsetX: backgroundOffsetX,
                backgroundOffsetY: backgroundOffsetY,
                backgroundPosition: backgroundPosition
            }), context.restore(), graphic.transMatrix.onlyTranslate() || context.setTransformForCurrent();
        } else context.highPerformanceSave(), context.setCommonStyle(graphic, graphic.attribute, x, y, graphicAttribute), 
        context.globalAlpha = backgroundOpacity * opacity, context.fillStyle = background, 
        context.fill(), context.highPerformanceRestore();
    }
    doDrawImage(context, data, b, params) {
        drawBackgroundImage(context, data, b, params);
    }
}

export const defaultBaseBackgroundRenderContribution = new DefaultBaseBackgroundRenderContribution;

const verticalPositionKeywords = new Set([ "top", "center", "bottom" ]);

export function getBackgroundImage(background) {
    var _a;
    return null !== (_a = null == background ? void 0 : background.background) && void 0 !== _a ? _a : background;
}

export function resolveBackgroundSizing({backgroundFit: backgroundFit, backgroundKeepAspectRatio: backgroundKeepAspectRatio}) {
    return backgroundFit ? backgroundKeepAspectRatio ? "cover" : "fill" : "auto";
}

export function isNoRepeatSizingMode(mode) {
    return "string" == typeof mode && mode.startsWith("no-repeat-");
}

const NO_REPEAT_SIZING_MAP = {
    "no-repeat-cover": "cover",
    "no-repeat-contain": "contain",
    "no-repeat-fill": "fill",
    "no-repeat-auto": "auto"
};

export function resolveBackgroundDrawMode({backgroundMode: backgroundMode, backgroundFit: backgroundFit, backgroundKeepAspectRatio: backgroundKeepAspectRatio}) {
    const sizing = NO_REPEAT_SIZING_MAP[backgroundMode];
    return sizing ? {
        backgroundRepeatMode: "no-repeat",
        backgroundSizing: sizing
    } : {
        backgroundRepeatMode: backgroundMode,
        backgroundSizing: resolveBackgroundSizing({
            backgroundFit: backgroundFit,
            backgroundKeepAspectRatio: backgroundKeepAspectRatio
        })
    };
}

function isPercentageValue(value) {
    return /^-?\d+(\.\d+)?%$/.test(value);
}

function parsePositionToken(value, remainSpace, startKeyword, centerKeyword, endKeyword) {
    if ("number" == typeof value && Number.isFinite(value)) return value;
    const normalizedValue = `${null != value ? value : ""}`.trim().toLowerCase();
    if (!normalizedValue || normalizedValue === startKeyword) return 0;
    if (normalizedValue === centerKeyword) return remainSpace / 2;
    if (normalizedValue === endKeyword) return remainSpace;
    if (isPercentageValue(normalizedValue)) return remainSpace * parseFloat(normalizedValue) / 100;
    const parsedValue = Number(normalizedValue);
    return Number.isFinite(parsedValue) ? parsedValue : 0;
}

function normalizeBackgroundPosition(position) {
    var _a, _b;
    if (Array.isArray(position)) return [ null !== (_a = position[0]) && void 0 !== _a ? _a : "left", null !== (_b = position[1]) && void 0 !== _b ? _b : "top" ];
    const tokens = `${null != position ? position : "top-left"}`.trim().toLowerCase().replace(/-/g, " ").split(/\s+/).filter(Boolean);
    if (0 === tokens.length) return [ "left", "top" ];
    if (1 === tokens.length) {
        const token = tokens[0];
        return "center" === token ? [ "center", "center" ] : verticalPositionKeywords.has(token) ? [ "center", token ] : [ token, "center" ];
    }
    let horizontal, vertical;
    const genericTokens = [];
    for (let i = 0; i < 2; i++) {
        const token = tokens[i];
        "left" !== token && "right" !== token ? "top" !== token && "bottom" !== token ? genericTokens.push(token) : vertical = token : horizontal = token;
    }
    return null == horizontal && genericTokens.length && (horizontal = genericTokens.shift()), 
    null == vertical && genericTokens.length && (vertical = genericTokens.shift()), 
    [ null != horizontal ? horizontal : "left", null != vertical ? vertical : "top" ];
}

export function resolveBackgroundPosition(position, remainWidth, remainHeight) {
    const [horizontalPosition, verticalPosition] = normalizeBackgroundPosition(position);
    return {
        x: parsePositionToken(horizontalPosition, remainWidth, "left", "center", "right"),
        y: parsePositionToken(verticalPosition, remainHeight, "top", "center", "bottom")
    };
}

function pickRenderableDimension(...values) {
    for (const value of values) if ("number" == typeof value && Number.isFinite(value) && value > 0) return value;
    return null;
}

export function resolveRenderableImageSize(data) {
    if (!data) return null;
    const width = pickRenderableDimension(data.naturalWidth, data.videoWidth, data.width), height = pickRenderableDimension(data.naturalHeight, data.videoHeight, data.height);
    return null == width || null == height ? null : {
        width: width,
        height: height
    };
}

export function drawBackgroundImage(context, data, b, params) {
    var _a, _b;
    const {backgroundMode: backgroundMode, backgroundFit: backgroundFit, backgroundKeepAspectRatio: backgroundKeepAspectRatio, backgroundScale: backgroundScale = 1, backgroundOffsetX: backgroundOffsetX = 0, backgroundOffsetY: backgroundOffsetY = 0, backgroundPosition: backgroundPosition = "top-left"} = params, targetW = b.width(), targetH = b.height(), sourceSize = resolveRenderableImageSize(data), {backgroundRepeatMode: backgroundRepeatMode, backgroundSizing: resolvedBackgroundSizing} = resolveBackgroundDrawMode({
        backgroundMode: backgroundMode,
        backgroundFit: backgroundFit,
        backgroundKeepAspectRatio: backgroundKeepAspectRatio
    });
    let w = targetW, h = targetH;
    if (targetW <= 0 || targetH <= 0) return;
    if ("no-repeat" === backgroundRepeatMode) {
        let drawWidth = null !== (_a = null == sourceSize ? void 0 : sourceSize.width) && void 0 !== _a ? _a : targetW, drawHeight = null !== (_b = null == sourceSize ? void 0 : sourceSize.height) && void 0 !== _b ? _b : targetH;
        if ("cover" !== resolvedBackgroundSizing && "contain" !== resolvedBackgroundSizing || !sourceSize) "fill" === resolvedBackgroundSizing && (drawWidth = targetW, 
        drawHeight = targetH); else {
            const scale = "cover" === resolvedBackgroundSizing ? Math.max(targetW / sourceSize.width, targetH / sourceSize.height) : Math.min(targetW / sourceSize.width, targetH / sourceSize.height);
            drawWidth = sourceSize.width * scale, drawHeight = sourceSize.height * scale;
        }
        drawWidth *= backgroundScale, drawHeight *= backgroundScale;
        const {x: x, y: y} = resolveBackgroundPosition(backgroundPosition, targetW - drawWidth, targetH - drawHeight);
        return void context.drawImage(data, b.x1 + x + backgroundOffsetX, b.y1 + y + backgroundOffsetY, drawWidth, drawHeight);
    }
    if (backgroundFit && "repeat" !== backgroundRepeatMode && sourceSize) {
        const resW = sourceSize.width, resH = sourceSize.height;
        if ("repeat-x" === backgroundRepeatMode) {
            w = resW * (targetH / resH), h = targetH;
        } else if ("repeat-y" === backgroundRepeatMode) {
            h = resH * (targetW / resW), w = targetW;
        }
        const dpr = context.dpr, canvas = canvasAllocate.allocate({
            width: w,
            height: h,
            dpr: dpr
        }), ctx = canvas.getContext("2d");
        ctx && (ctx.inuse = !0, ctx.clearMatrix(), ctx.setTransformForCurrent(!0), ctx.clearRect(0, 0, w, h), 
        ctx.drawImage(data, 0, 0, w, h), data = canvas.nativeCanvas), canvasAllocate.free(canvas);
    }
    const dpr = context.dpr, pattern = context.createPattern(data, backgroundRepeatMode);
    pattern.setTransform && pattern.setTransform(new DOMMatrix([ 1 / dpr, 0, 0, 1 / dpr, 0, 0 ])), 
    context.fillStyle = pattern, context.translate(b.x1, b.y1), context.fillRect(0, 0, targetW, targetH), 
    context.translate(-b.x1, -b.y1);
}

export class DefaultBaseInteractiveRenderContribution {
    constructor(subRenderContribitions) {
        this.subRenderContribitions = subRenderContribitions, this.time = BaseRenderContributionTime.afterFillStroke, 
        this.useStyle = !0, this.order = 0;
    }
    drawShape(graphic, context, x, y, doFill, doStroke, fVisible, sVisible, graphicAttribute, drawContext, fillCb, strokeCb, options) {
        this._subRenderContribitions || (this._subRenderContribitions = this.subRenderContribitions.getContributions()), 
        this._subRenderContribitions.forEach((c => {
            c.render(graphic, context, x, y, doFill, doStroke, fVisible, sVisible, graphicAttribute, drawContext, fillCb, strokeCb, options);
        }));
    }
}

export class DefaultBaseClipRenderBeforeContribution {
    constructor() {
        this.time = BaseRenderContributionTime.beforeFillStroke, this.useStyle = !0, this.order = 0;
    }
    drawShape(graphic, context, x, y, doFill, doStroke, fVisible, sVisible, graphicAttribute, drawContext, fillCb, strokeCb, options) {
        var _a, _b;
        const {clipConfig: clipConfig} = graphic.attribute;
        if (!clipConfig) return;
        const clipPath = graphic.getClipPath();
        if (!clipPath) return;
        const draw = !(fillCb || strokeCb), b = graphic.AABBBounds, width = null !== (_a = graphic.attribute.width) && void 0 !== _a ? _a : b.width(), height = null !== (_b = graphic.attribute.height) && void 0 !== _b ? _b : b.height();
        draw && context.save(), context.beginPath(), !1 === clipPath.draw(context, [ width, height ], x + width / 2, y + height / 2, 0) && context.closePath(), 
        fillCb && fillCb(context, graphic.attribute, graphicAttribute, !0), draw && context.clip();
    }
}

export const defaultBaseClipRenderBeforeContribution = new DefaultBaseClipRenderBeforeContribution;

export class DefaultBaseClipRenderAfterContribution {
    constructor() {
        this.time = BaseRenderContributionTime.afterFillStroke, this.useStyle = !0, this.order = 0;
    }
    drawShape(graphic, context, x, y, doFill, doStroke, fVisible, sVisible, graphicAttribute, drawContext, fillCb, strokeCb, options) {
        const {clipConfig: clipConfig} = graphic.attribute;
        if (!clipConfig) return;
        graphic.getClipPath() && (fillCb || strokeCb || context.restore());
    }
}

export const defaultBaseClipRenderAfterContribution = new DefaultBaseClipRenderAfterContribution;
//# sourceMappingURL=base-contribution-render.js.map
